import { useQuery } from "@apollo/client/react";
import useGetLineFromCache from "hooks/apollo/line/useGetLineFromCache";
import { useSchedulerState } from "hooks/state";
import useTimeZone from "hooks/useTimeZone";
import Uuid from "utils/Uuid";
import { GetSchedulerData } from "./schedulerData.gql";

let lastQueryId = 0;

const mostRecentFetchMore = ({ variables, fetchMore }) => {
  const queryId = Uuid.generate();
  lastQueryId = queryId;

  return fetchMore({
    updateQuery: (previousResult, result) => {
      if (!result.fetchMoreResult || lastQueryId !== queryId) {
        return previousResult;
      }

      return result.fetchMoreResult;
    },
    variables,
  });
};
export default function useFetchSchedulerData() {
  const {
    state: { dataTimeRange },
  } = useSchedulerState();
  const getLineFromCache = useGetLineFromCache();
  const { overrideToSiteTimeZone } = useTimeZone();

  const { data, fetchMore, loading, error } = useQuery(GetSchedulerData, {
    variables: {
      endDate: overrideToSiteTimeZone(dataTimeRange.endDate),
      startDate: overrideToSiteTimeZone(dataTimeRange.startDate),
    },
  });

  const hydrateBlocks = (blocks) => {
    return {
      downtimeBlocks: blocks.downtimeBlocks.map((block) => {
        return {
          ...block,
          line: getLineFromCache(block.line.id) || block.line,
        };
      }),
      workBlocks: blocks.workBlocks.map((block) => {
        return {
          ...block,
          line: getLineFromCache(block.line.id) || block.line,
        };
      }),
    };
  };

  return {
    blocks: data ? hydrateBlocks(data.blocks) : { downtimeBlocks: [], workBlocks: [] },
    data,
    error,
    loading,
    refetch: ({ dataTimeRange: newDataTimeRange } = {}) => {
      const actualStart = newDataTimeRange?.startDate || dataTimeRange.startDate;
      const actualEnd = newDataTimeRange?.endDate || dataTimeRange.endDate;

      return mostRecentFetchMore({
        fetchMore,
        variables: {
          endDate: overrideToSiteTimeZone(actualEnd),
          startDate: overrideToSiteTimeZone(actualStart),
        },
      });
    },
    shiftInstances: data ? data.shiftInstances : [],
    unavailabilities: data ? data.unavailabilities : [],
  };
}
